import { twMerge } from 'tailwind-merge';

type BasicButtonProps = {
  text: string;
  disabled?: boolean;
  ariaDisabled?: boolean;
  onClick?: () => void;
  variant?: 'default' | 'orange';
  className?: string;
  textClassName?: string;
  rightIcon?: React.ReactNode;
};

const VARIANT_STYLES = {
  default: {
    activeGradient: 'tw-bg-stakeButtonGradient',
    disabledBg: 'tw-bg-[#2242A7]',
    disabledText: 'tw-text-[#456FF3]',
  },
  orange: {
    activeGradient: 'tw-bg-stakeButtonOrangeGradient',
    disabledBg: 'tw-bg-[#632600]',
    disabledText: 'tw-text-[#913605]',
  },
};

export const BasicButton = ({
  text,
  disabled = false,
  ariaDisabled,
  onClick,
  variant = 'default',
  className,
  textClassName,
  rightIcon,
}: BasicButtonProps) => {
  const isDisabled = ariaDisabled ?? disabled;
  const styles = VARIANT_STYLES[variant];

  return (
    <button
      type="button"
      disabled={ariaDisabled !== undefined ? false : disabled}
      aria-disabled={ariaDisabled}
      onClick={isDisabled ? undefined : onClick}
      className={twMerge(
        'tw-flex tw-items-center tw-justify-center tw-gap-[5px] tw-rounded-[60px] tw-border-none tw-px-[15px]',
        isDisabled ? `tw-cursor-not-allowed ${styles.disabledBg}` : `${styles.activeGradient} tw-cursor-pointer`,
        className
      )}
    >
      <span
        className={twMerge(
          'tw-text-[14px] tw-font-semibold',
          isDisabled ? styles.disabledText : 'tw-text-white',
          textClassName
        )}
      >
        {text}
      </span>
      {rightIcon !== undefined && rightIcon}
    </button>
  );
};
